import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { MOCK_PRODUCTS } from "../data/products";
import { useCart } from "../hooks/useCart";
import styled from "styled-components";
import { Button, PageTitle } from "../components/styled";

const ProductDetailContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  margin-top: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

const ProductImageLarge = styled.img`
  width: 100%;
  height: 500px;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const ProductDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const ProductTitle = styled.h1`
  font-size: 2rem;
  color: #333;
  margin: 0;
`;

const ProductPrice = styled.div`
  font-size: 2rem;
  font-weight: bold;
  color: #007bff;
`;

const ProductDescription = styled.p`
  font-size: 1.1rem;
  line-height: 1.6;
  color: #666;
`;

const ProductCategory = styled.span`
  background: #f8f9fa;
  color: #6c757d;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 500;
  width: fit-content;
`;

const BackButton = styled(Button)`
  background: #6c757d;
  width: auto;
  margin-right: 1rem;

  &:hover {
    background: #5a6268;
  }
`;

export const ProductDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { addItem } = useCart();
  const [imageError, setImageError] = useState(false);

  const product = MOCK_PRODUCTS.find((p) => p.id === parseInt(id || "0"));

  if (!product) {
    return (
      <>
        <PageTitle>Product Not Found</PageTitle>
        <p style={{ textAlign: "center" }}>
          The product you're looking for doesn't exist.
        </p>
        <div style={{ textAlign: "center", marginTop: "2rem" }}>
          <Button onClick={() => navigate("/")} style={{ width: "auto" }}>
            Back to Home
          </Button>
        </div>
      </>
    );
  }

  const handleAddToCart = () => {
    addItem(product);
  };

  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <>
      <div style={{ marginBottom: "2rem" }}>
        <BackButton onClick={() => navigate(-1)}>← Back</BackButton>
      </div>

      <ProductDetailContainer>
        {imageError ? (
          <div
            style={{
              width: "100%",
              height: "500px",
              backgroundColor: "#f8f9fa",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#666",
              fontSize: "1.2rem",
              borderRadius: "8px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            No Image Available
          </div>
        ) : (
          <ProductImageLarge
            src={product.image}
            alt={product.name}
            onError={handleImageError}
          />
        )}
        <ProductDetails>
          <ProductCategory>{product.category}</ProductCategory>
          <ProductTitle>{product.name}</ProductTitle>
          <ProductPrice>${product.price.toFixed(2)}</ProductPrice>
          <ProductDescription>{product.description}</ProductDescription>
          <Button
            onClick={handleAddToCart}
            style={{ width: "fit-content", padding: "1rem 2rem" }}
          >
            Add to Cart
          </Button>
        </ProductDetails>
      </ProductDetailContainer>
    </>
  );
};
